import { render, staticRenderFns } from "./Parcel-Inbound.vue?vue&type=template&id=7db5f2dc&scoped=true"
import script from "./Parcel-Inbound.vue?vue&type=script&lang=js"
export * from "./Parcel-Inbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5f2dc",
  null
  
)

export default component.exports